import React, { useState, useEffect, useRef, ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { isTokenExpired, refreshToken, getUserDetails } from './AuthUtil';

import loadingimg from '../Assets/images/loading image 1.png';
import { CircularProgress } from '@mui/material';
import { profileModel } from '../Axios/AxiosConfig';
// import { generateToken, messaging } from '../Notifications.jsx/firebase';
// import { onMessage, isSupported } from "firebase/messaging";
// import AppointmentStore from '../DataRepo/AppointmentStore';
const cookies = new Cookies();

interface UserInfo {
  userName: string;
  userId: string;
}

interface ProfileData {
  firstname?: string;
  [key: string]: any;
}

interface Appointment {
  appointment_status: string;
  [key: string]: any;
}

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }: ProtectedRouteProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [callActive, setCallActive] = useState(false);
  const [ProfileData, setProfileData] = useState<ProfileData[]>([])
  const zegoCloudInstance = useRef(null);
  const videoCallDivRef = useRef(null);
  
  const userDetails = getUserDetails() as any;

  // const { getAppointments, Appointments } = AppointmentStore()

  const [userInfo, setUserInfo] = useState({
    userName: "",
    userId: "",
  });

  const [alertMessage, setAlertMessage] = useState("");

  const [showAlert, setShowAlert] = useState(false);

  const showCustomAlert = (message: string) => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const closeAlert = () => {
    setShowAlert(false);
  };

  useEffect(() => {

    const checkAuthentication = async () => {
      let accessToken = cookies.get('accessToken');

      if (!accessToken || isTokenExpired(accessToken)) {
        const refreshed = await refreshToken();
        accessToken = cookies.get('accessToken');

        if (!refreshed || !accessToken) {
          setIsAuthenticated(false as any);
          return;
        }
      }

      if (isTokenExpired(accessToken)) {
        setIsAuthenticated(false as any);
      } else {
        setIsAuthenticated(true as any);
      }
    };

    checkAuthentication();
  }, []);

  useEffect(() => {
    if (isAuthenticated === false) {
      navigate('/login', { state: { from: location?.pathname } });
    }
    //  else {
    //   document.addEventListener('click', handleUserInteraction);
    //   // isSupported().then((supported : any) => {
    //   //   if (supported) {
    //   //     generateToken();
    //   //     onMessage(messaging, (payload : any) => {
    //   //       console.log('Message received:', payload);
    //   //     });
    //   //   } else {
    //   //     console.log('Firebase Messaging is not supported in this environment.');
    //   //   }
    //   // });
    //   return () => {
    //     document.removeEventListener('click', handleUserInteraction);
    //   };
    // }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      if (location.pathname === "/") {
        
        // requestMediaPermissions();
      }
      else {
        setAlertMessage('')
        setShowAlert(false)
      }
    }
  }, [location])

  // const handleUserInteraction = () => {
  //   document.removeEventListener('click', handleUserInteraction);
  //   // init();
  // };

  const getProfile = async (id : any) => {
    try {
      let res = await profileModel.get(`/Profile/${id}`)
      if (res.status === 200) {
        const profile = res?.data
        setProfileData(profile)
      }
    }
    catch (err : any) {
      console.log(err?.response?.data)
    }
  }

  useEffect(() => {
    getProfile(userDetails?.UID as any)
    // getAppointments(userDetails?.UID)
  }, [])

  // const requestMediaPermissions = async () => {
  //   try {

  //     if (location.pathname !== "/") return;

  //     // const hasNewAppointments : any = Appointments?.filter(e => e?.appointment_status === 'upcoming')?.length > 0

  //     // if (!hasNewAppointments) return;

  //     const cameraPermission = await navigator.permissions.query({ name: 'camera' });

  //     const microphonePermission = await navigator.permissions.query({ name: 'microphone' });

  //     if (cameraPermission.state === 'granted' && microphonePermission.state === 'granted') return;

  //     if (cameraPermission.state === 'denied' || microphonePermission.state === 'denied') {
  //       showCustomAlert("Camera and microphone access is denied. Please enable them in your browser settings.");
  //       return;
  //     }

  //     const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });

  //     stream.getTracks().forEach(track => track.stop());

  //   }

  //   catch (error : any) {
  //     console.log('Camera and microphone access denied:', error);
  //   }

  // };

  // const init = async ( ) => {

  //   await requestMediaPermissions();

  //   const userId = userDetails?.UID?.split('-')[0];

  //   const userName = `${ProfileData?.firstname || 'user'}`;

  //   setUserInfo({ userName, userId });

  //   const appID = 197553733;

  //   const serverSecret = "0fbade5cc539bd4335b2336f0c75baf4";

  //   const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
  //     appID,
  //     serverSecret,
  //     null,
  //     userId,
  //     userName
  //   );

  //   zegoCloudInstance.current = ZegoUIKitPrebuilt.create(kitToken);

  //   zegoCloudInstance.current.addPlugins({ ZIM });

  //   zegoCloudInstance.current.setCallInvitationConfig({
  //     ringtoneConfig: {
  //       incomingCallUrl: 'https://aiwellassets.s3.ap-south-1.amazonaws.com/in-y2mate.com+-+Space+Guitar+Bliss+Ringtone.mp3',
  //     },

  //     onCallInviteReceived: (data) => {
  //       zegoCloudInstance.current.joinRoom({
  //         container: videoCallDivRef.current,
  //         roomID: data.roomID,
  //         scenario: {
  //           mode: ZegoUIKitPrebuilt.OneONoneCall,
  //         },
  //         onLeaveRoom: () => {
  //           setCallActive(false);
  //         },
  //       });
  //       setCallActive(true);
  //     },

  //     onCallInviteRejected: () => {
  //       console.log('Call was rejected.');
  //     },

  //     onCallInviteCanceled: () => {
  //       console.log('Call was canceled.');
  //       setCallActive(false);
  //     },

  //   });

  // };

  if (isAuthenticated === null) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: '100vh' }}>
        <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
          <CircularProgress style={{ width: "100%", height: "100%", color: "#DA6E0B" }} thickness={1} />
          <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img src={loadingimg} style={{ width: "80%", height: "80%" }} alt="Loading" />
          </div>
        </div>
      </div>
    );
  }

  return isAuthenticated ? (
    <>
      {children}
      {showAlert && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#333',
          color: 'white',
          padding: '20px',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          textAlign: 'center',
          zIndex: 1000
        }}>
          <p style={{
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 500,
          }}>{alertMessage}</p>
          <button
            style={{
              marginTop: '10px',
              backgroundColor: '#DA6E0B',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              cursor: 'pointer',
              borderRadius: '5px'
            }}
            onClick={closeAlert}
          >
            OK
          </button>
        </div>
      )}

      <div ref={videoCallDivRef} style={{ zIndex: 2000 }}></div>
    </>
  ) : null;

};

export default ProtectedRoute;